import fontColorContrast from 'font-color-contrast'
import React, { useEffect, useState } from 'react'
import { Alert, Col, Form, Row, Spinner } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import ConfirmEmailForm from './ConfirmEmailForm'
import { checkList, fetchBlackList, isIterableArray, useClientInfo } from '../../../block-slider/utils'
import eyeSrc from '../../../../img/eye.svg'
import eyeCloseSrc from '../../../../img/eye-close.svg'
import axios from 'axios'
import { isValidPhoneNumber } from 'react-phone-number-input'
import PhoneInput from 'react-phone-number-input/input'

export const phoneStartValueCode = '+7'

const FormRegister = ({ data, query, formData, pageData }) => {

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: { errors, isValid }, //isValid
    } = useForm({
        // shouldUseNativeValidation: true,
        // shouldFocusError: false
        // reValidateMode: 'onBlur',
        mode: 'onChange'
    })

    const {
        button_color,
        text_1,
        text_2,
        text_10 = 'Карта успешно добавлена',
        text_15 = 'Регистрация',

    } = data.setting


    const { receipt, number_card } = query

    const [isConfirmMode, setIsConfirmMode] = useState(false)
    const [confirmResendData, setConfirmResendData] = useState(null)

    const [isLoading, setIsLoading] = useState(false); // загрузка при отправке
    const [isAlertSuccess, setIsAlertSuccess] = useState(false);
    const [isAlertError, setIsAlertError] = useState(false);
    const [textOnError, setTextOnError] = useState('');


    const [isPassword, setIsPassword] = useState(true)


    const [passwordInputData, setPasswordInputData] = useState(null)
    const [emailInputData, setEmailInputData] = useState(null)
    const [nameInputData, setNameInputData] = useState(null)
    const [surnameInputData, setSurnameInputData] = useState(null)
    const [phoneInputData, setPhoneInputData] = useState(null)
    const [cardNumberInputData, setCardNumberInputData] = useState(null)
    const [checkboxInputData1, setCheckboxInputData1] = useState(null)
    const [checkboxInputData2, setCheckboxInputData2] = useState(null)


    const [blackList, setBlackList] = useState(null)
    useEffect(() => {
        fetchBlackList(10).then(res => {
            setBlackList(res)
        })
    }, [])


    useEffect(() => {
        if (isIterableArray(data?.items)) {
            const passwordI = data.items.find(i => i.forEmail === 'password')
            const emailI = data.items.find(i => i.forEmail === 'email')
            const nameI = data.items.find(i => i.forEmail === "first_name")
            const surnameI = data.items.find(i => i.forEmail === "last_name")
            const phoneI = data.items.find(i => i.forEmail === "phone")
            const cardI = data.items.find(i => i.forEmail === "number_card")
            const checkboxI1 = data.items.filter(i => i.type === 1)
            const checkboxI2 = data.items.filter(i => i.type === 11)
            if (passwordI) setPasswordInputData(passwordI)
            if (emailI) setEmailInputData(emailI)
            if (nameI) setNameInputData(nameI)
            if (surnameI) setSurnameInputData(surnameI)
            if (phoneI) setPhoneInputData(phoneI)
            if (cardI) setCardNumberInputData(cardI)
            if (checkboxI1?.[0]) setCheckboxInputData1(checkboxI1[0])
            if (checkboxI2?.[0]) setCheckboxInputData2(checkboxI2[0])

        }
    }, [data])

    useEffect(() => {
        if (formData) {
            setValue('email', formData.email)
            setValue('phone', phoneStartValueCode)
        }
    }, [formData]);

    useEffect(() => {
        if (receipt) {
            setValue('number_check', receipt)
        }
        else {
            setValue('number_check', '')
        }
    }, [receipt]);

    useEffect(() => {
        if (number_card) {
            setValue('number_card', number_card)
        }
        else {
            setValue('number_card', '')
        }
    }, [number_card]);



    const onSubmit = (submitData) => {
        const sendData = submitData
        delete sendData.check
        handleSend(sendData)
    }


    const { fetchClientInfo } = useClientInfo()

    const handleSend = async (sendData) => {

        const info = await fetchClientInfo()

        sendData.clientInfo = {
            ...info,
            page_name: pageData.name_rkn,
            form_name: data.name_rkn
        }

        setIsLoading(true)
        axios
            .post(`${process.env.REACT_APP_API_BASE}/registration/new-card`, sendData)
            .then((response) => {
                if (response?.data && response.data?.res) {
                    if (response.data.res === 'Success') {
                        setIsConfirmMode(true)
                        setConfirmResendData(sendData)
                        setIsAlertSuccess(true)
                        setIsAlertError(false)
                    }

                    if (response.data.res === 'Error') {
                        setIsAlertError(true)
                        const errText = data?.setting?.[response.data?.msgKey] || 'Что-то пошло не так, попробуйте повторить позже'
                        setTextOnError(errText)
                    }
                }
                // reset()
            })
            .catch((err) => {
                console.log(err)
                setIsAlertError(true)
                setTextOnError('Что-то пошло не так')
            })
            .finally(() => {
                setIsLoading(false)
            });
    }
    return (
        <>
            {data.title && <div className='title' dangerouslySetInnerHTML={{ __html: data.title }} />}
            {
                isConfirmMode ?
                    <ConfirmEmailForm
                        data={data}
                        handleResend={() => {
                            handleSend(confirmResendData)
                        }}
                        confirmResendData={confirmResendData}
                        onConfirm={(token) => {
                            localStorage.setItem('galaxy-token', token)
                        }}
                    />
                    :
                    <form onSubmit={handleSubmit(onSubmit)}>

                        <div className='light buildedPage-type_8-form'>
                            <div className='h5 mb-3' dangerouslySetInnerHTML={{ __html: text_15 }} />
                            {
                                isAlertSuccess &&
                                <Alert variant={'success'} onClose={() => setIsAlertSuccess(false)} dismissible>
                                    <div dangerouslySetInnerHTML={{ __html: text_10 }} />
                                </Alert>
                            }
                            {
                                isAlertError &&
                                <Alert variant={'danger'} onClose={() => {
                                    setIsAlertError(false)
                                    setTextOnError('')
                                }} dismissible>
                                    <Alert.Heading style={{ fontSize: '1.15rem' }}>Ошибка</Alert.Heading>
                                    <p className='mb-0'>{textOnError}</p>
                                </Alert>
                            }
                            <Row>
                                {
                                    nameInputData &&
                                    <Col md={6} className='mb-2'>
                                        <div>
                                            <Form.Control
                                                className='mb-0'
                                                placeholder={nameInputData.text}
                                                type="text"
                                                {...register(nameInputData.forEmail, {
                                                    required: nameInputData.required,
                                                })}
                                            />
                                            <Form.Control.Feedback type="invalid" className='d-block m-0' style={{ minHeight: 20 }}>
                                                <>
                                                    {
                                                        errors?.[nameInputData.forEmail]?.type === 'required' &&
                                                        'Обязательно к заполнению'
                                                    }
                                                </>
                                            </Form.Control.Feedback>
                                        </div>
                                    </Col>
                                }
                                {
                                    surnameInputData &&
                                    <Col md={6} className='mb-2'>
                                        <div>
                                            <Form.Control
                                                className='mb-0'
                                                placeholder={surnameInputData.text}
                                                type="text"
                                                {...register(surnameInputData.forEmail, {
                                                    required: surnameInputData.required,
                                                })}
                                            />
                                            <Form.Control.Feedback type="invalid" className='d-block m-0' style={{ minHeight: 20 }}>
                                                <>
                                                    {
                                                        errors?.[surnameInputData.forEmail]?.type === 'required' &&
                                                        'Обязательно к заполнению'
                                                    }
                                                </>
                                            </Form.Control.Feedback>
                                        </div>
                                    </Col>
                                }
                                {
                                    emailInputData &&
                                    <Col md={6} className='mb-2' >
                                        <Form.Control
                                            className='mb-0'
                                            placeholder={emailInputData.text}
                                            type="email"
                                            {...register(emailInputData.forEmail, {
                                                required: emailInputData.required,
                                                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                validate: (value) => {
                                                    return !checkList(blackList, value)
                                                },
                                            })}
                                        />
                                        {
                                            <Form.Control.Feedback type="invalid" className='d-block m-0' style={{ minHeight: 20 }}>
                                                {
                                                    errors?.[emailInputData.forEmail]?.type === 'required' &&
                                                    'Обязательно к заполнению'
                                                }
                                                {
                                                    errors?.[emailInputData.forEmail]?.type === 'pattern' &&
                                                    'E-mail заполнен некорректно '
                                                }
                                                {
                                                    errors?.[emailInputData.forEmail]?.type === "validate" &&
                                                    (blackList?.text || "Недопустимое значение E-mail")
                                                }
                                            </Form.Control.Feedback>
                                        }
                                    </Col>
                                }
                                {
                                    passwordInputData &&
                                    <Col md={6} className='mb-2'>
                                        <div>
                                            <div style={{ position: 'relative' }}>
                                                <Form.Control
                                                    className='mb-0'
                                                    placeholder={passwordInputData.text}
                                                    type={isPassword ? "password" : 'text'}
                                                    {...register(passwordInputData.forEmail, {
                                                        required: !!passwordInputData.required,
                                                        minLength: 8,
                                                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
                                                    })}
                                                />
                                                <div
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '6px 12px',
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 0,
                                                    }}
                                                    onClick={() => setIsPassword(prev => !prev)}
                                                >
                                                    {
                                                        isPassword ?
                                                            <img src={eyeSrc} style={{ width: 30, height: 22 }} alt="Eye" />
                                                            :
                                                            <img src={eyeCloseSrc} style={{ width: 30, height: 22 }} alt="Eye" />
                                                    }
                                                </div>
                                            </div>
                                            {
                                                errors[passwordInputData.forEmail] &&
                                                <Form.Control.Feedback type="invalid" className='d-block m-0' style={{ minHeight: 20 }}>
                                                    {
                                                        errors[passwordInputData.forEmail].type === 'minLength' &&
                                                        "Пароль должен содержать минимум 8 символов"
                                                    }
                                                    {
                                                        errors[passwordInputData.forEmail].type === 'pattern' &&
                                                        "Пароль обязательно должен содержать символы, цифры и заглавные и строчные латинские буквы"
                                                    }
                                                    {
                                                        errors[passwordInputData.forEmail].type === 'required' &&
                                                        "Обязательно к заполнению"
                                                    }
                                                </Form.Control.Feedback>
                                            }
                                        </div>
                                    </Col>
                                }
                                {
                                    phoneInputData &&
                                    <Col md={6} className='mb-2'>
                                        <Controller
                                            name={phoneInputData.forEmail}
                                            control={control}
                                            rules={{
                                                validate: (value) => isValidPhoneNumber(value || ''),
                                                required: phoneInputData.requiredƒ
                                            }}
                                            render={({ field }) => (
                                                <PhoneInput
                                                    {...field}
                                                    className='form-control mb-0'
                                                    id={phoneInputData.forEmail}
                                                    placeholder={phoneInputData.text}
                                                    onChange={(e) => {
                                                        setValue(phoneInputData.forEmail, e ? e : phoneStartValueCode)
                                                    }}
                                                    type='tel'
                                                    autoComplete="tel"
                                                />
                                            )}
                                        />
                                        <Form.Control.Feedback type="invalid" className='d-block m-0' style={{ minHeight: 20 }}>
                                            {errors[phoneInputData.forEmail]?.type === 'validate' && 'Телефон заполнен некорректно'}
                                            {errors[phoneInputData.forEmail]?.type === 'required' && "Телефон обязателен к заполнению "}
                                        </Form.Control.Feedback>
                                    </Col>
                                }
                            </Row>
                            <hr />
                            {
                                cardNumberInputData &&
                                <div style={{ marginRight: 60 }}>
                                    <Controller
                                        name={cardNumberInputData.forEmail}
                                        control={control}
                                        rules={{
                                            required: !!cardNumberInputData.required
                                        }}
                                        render={({ field }) => {
                                            return (
                                                <>
                                                    <p style={{ fontFamily: "Arial", fontWeight: 500, marginBottom: '0.65em' }}>{cardNumberInputData.text}</p>
                                                    <p className='text-muted' style={{ fontFamily: "Arial", fontWeight: 500, fontSize: '1.3em' }}>{field.value}</p>
                                                    <Form.Control
                                                        {...field}
                                                        readOnly={true}
                                                        placeholder={cardNumberInputData.text}
                                                        type="hidden"
                                                    />
                                                </>
                                            )
                                        }}
                                    />
                                </div>
                            }
                            <Row className='mt-3'>
                                <Col md={6} lg={7} xxl={8}>
                                    {
                                        checkboxInputData1 &&
                                        <div className='mb-2'>
                                            <Form.Check
                                                className='d-inline-block'
                                                type="checkbox"
                                                label={<span dangerouslySetInnerHTML={{ __html: checkboxInputData1.text }} />}
                                                id={'check1'}
                                                {...register('check1', { required: true })}
                                            />
                                            {
                                                errors.check &&
                                                <Form.Control.Feedback type="invalid" className='d-block'>
                                                    Обязательно к заполнению
                                                </Form.Control.Feedback>
                                            }
                                        </div>
                                    }
                                    {
                                        checkboxInputData2 &&
                                        <div className='mb-2'>
                                            <Form.Check
                                                className='d-inline-block'
                                                type="checkbox"
                                                label={<span dangerouslySetInnerHTML={{ __html: checkboxInputData2.text }} />}
                                                id={'check2'}
                                                {...register('check2', { required: true })}
                                            />
                                            {
                                                errors.check &&
                                                <Form.Control.Feedback type="invalid" className='d-block'>
                                                    Обязательно к заполнению
                                                </Form.Control.Feedback>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col md={6} lg={5} xxl={4}>
                                    <button
                                        disabled={!isValid}
                                        className='btn btn-submit'
                                        // type='submit'
                                        style={{
                                            backgroundColor: button_color,
                                            color: fontColorContrast(button_color)
                                        }}
                                    >
                                        {
                                            isLoading ?
                                                <Spinner animation='border' />
                                                :
                                                <div dangerouslySetInnerHTML={{ __html: text_2 || 'Отправить' }}></div>
                                        }
                                    </button>

                                    {
                                        text_1 &&
                                        <div className='text_under mt-3' dangerouslySetInnerHTML={{ __html: text_1 }} />
                                    }
                                </Col>
                            </Row>
                        </div>
                    </form>
            }
        </>
    )
}

export default FormRegister